import { render, staticRenderFns } from "./SimcardsBatch.vue?vue&type=template&id=5723fc72"
import script from "./SimcardsBatch.vue?vue&type=script&lang=js"
export * from "./SimcardsBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports